var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.52901 4.025C5.57901 10.5 14.904 22.5 14.904 22.5V37.5C14.904 38.875 16.029 40 17.404 40H22.404C23.779 40 24.904 38.875 24.904 37.5V22.5C24.904 22.5 34.204 10.5 39.254 4.025C39.5405 3.65593 39.7177 3.21382 39.7652 2.74902C39.8128 2.28421 39.7289 1.81539 39.5231 1.39593C39.3172 0.976469 38.9978 0.623233 38.601 0.376441C38.2043 0.12965 37.7462 -0.000780088 37.279 3.5101e-06H2.50401C0.42901 3.5101e-06 -0.74599 2.375 0.52901 4.025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_Filter.b6752f59a44c5c0d47be8549dbd2d394.svg";
export { ForwardRef as ReactComponent };